import { render, staticRenderFns } from "./HIcon.vue?vue&type=template&id=5059fb86&scoped=true&"
import script from "./HIcon.vue?vue&type=script&lang=js&"
export * from "./HIcon.vue?vue&type=script&lang=js&"
import style0 from "./HIcon.vue?vue&type=style&index=0&id=5059fb86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5059fb86",
  null
  
)

export default component.exports